import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../components/hooks/useAuth";
import { Copyright } from "../components/views/Copyright";

export const AuthLayout = () => {
  const { token, user } = useAuth();

  // If authenticated, redirect away from auth pages
  if (token && user) {
    if (user?.onboarded === false) {
      return <Navigate to="/onboarding" replace />;
    }
    return <Navigate to="/home" replace />;
  }
  // Token exists but user not loaded yet — avoid flicker
  if (token && !user) return null;

  return (
    <div className="flex min-h-screen flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gradient-to-br from-white via-gray-50 to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-black relative overflow-hidden">
      <Outlet />
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <Copyright />
      </div>
    </div>
  );
};
